const Projects = [
  {
    name: "Show Reel 2023",
    imgUrl: "https://c.l3n.co/i/qQRPvx.gif",
    hrefUrl: "showreel",
    medium: "Animation, 2D, 3D",
    info: "My updated 3D&2D Animation Showreel!",
    otherImgs: [],
    classImg: "card-wide",
    fullVid: "https://player.vimeo.com/video/848250461?h=3aa34e6abb",
    showreel: true,
  },
  {
    name: "The Last Drop",
    imgUrl: "https://a.l3n.co/i/QgKYJm.webp",
    hrefUrl: "the-last-drop",
    medium: "3D Animation",
    info: '"The Last Drop" is a short film that delves into topics of miscarriage and motherhood, fear and traumatize experience. The main theme is an attempt to get into the skin of a person who has put himself in the experience that has led to the post-trauma in order to fulfill his most desired wish.',
    otherImgs: [
      "https://a.l3n.co/i/QgKYJm.webp",
      "https://a.l3n.co/i/QgKvoZ.webp",
      "https://c.l3n.co/i/QgKM2P.webp",
      "https://b.l3n.co/i/QgKoei.webp",
      "https://a.l3n.co/i/qQmeYD.jpeg",
      "https://b.l3n.co/i/qQmLJA.jpeg",
    ],
    classImg: "regular",
  },
  {
    name: "Ukrainian Mother",
    imgUrl: "https://a.l3n.co/i/qQBfaz.gif",
    hrefUrl: "ukrainian-mother",
    medium: "Animation, 2D, 3D",
    info: [
      "Ukrainian Mother is a project exploring the dimensions of animated comics, a fragmented space with dynamic visuals. The project serves as part of the research for ",
      <a
        href="/project/the-last-drop"
        style={{ fontStyle: "oblique", color: "#89CFF0" }}
      >
        "The Last Drop"
      </a>,
      " a short film about miscarriage and motherhood.",
    ],
    otherImgs: [],
    classImg: "regular",
    fullVid: "https://player.vimeo.com/video/872178998?h=8bdd751360",
    showreel: true,
  },
  {
    name: "Communal.ka",
    imgUrl: "https://i3.lensdump.com/i/TuwKK1.webp",
    hrefUrl: "communal.ka",
    medium: "2D Illustration, Comic Book",
    info: "Communal.ka is comic zin narrating memories from my childhood during my time living in a soviet-type communal apartment in Saint-Petersburg",
    otherImgs: [
      "https://i2.lensdump.com/i/TDPZbc.webp",
      "https://i3.lensdump.com/i/Tuy7vP.webp",
      "https://i.lensdump.com/i/TuyOGm.webp",
      "https://i3.lensdump.com/i/Tuylki.webp",
    ],
    classImg: "regular",
  },
  {
    name: "A Story About Libi",
    imgUrl: "https://i1.lensdump.com/i/Tuw9MQ.gif",
    hrefUrl: "a-story-about-libi",
    medium: "2D Animation",
    info: "This is a video essay I created as part of the Studio course. The work pictures controversial three-dimensional statements about myself.",
    otherImgs: [
      "https://i1.lensdump.com/i/TuyuLT.webp",
      "https://i1.lensdump.com/i/Tuyflr.gif",
      "https://i1.lensdump.com/i/Tuycr3.gif",
      "https://i3.lensdump.com/i/TuyFXF.gif",
    ],
    classImg: "regular",
    fullVid: "https://www.youtube.com/embed/uw4jt7pdxak",
  },
  {
    name: "Magic Props Series",
    imgUrl: "https://a.l3n.co/i/qQCqFc.gif",
    hrefUrl: "magic-props",
    medium: "3D Modeling",
    info: "",
    otherImgs: ["https://c.l3n.co/i/QOuSzc.webp"],
    classImg: "regular",
    fullVid: "https://player.vimeo.com/video/850105312?h=06138b5577",
  },
  {
    name: "The Table",
    imgUrl: "https://c.l3n.co/i/qQeeoP.gif",
    hrefUrl: "the-table",
    medium: "2D and 3D Animation",
    info: "The short resulted from my reflection on collecting and separating from objects to which you have an emotional attachment. Minimalism and the Marie Kondo movement may not be properly understood and can lead to overuse. While we think about ourselves, our comfort, global warming - I wondered how the objects themselves experience this. ",
    otherImgs: [],
    classImg: "regular",
    fullVid: "https://www.youtube.com/embed/Tx-pr6-1I_E",
  },
  {
    name: "A Guest",
    imgUrl: "https://i.lensdump.com/i/TuwRlF.webp",
    hrefUrl: "a-guest",
    medium: "Digital Painting",
    info: "",
    otherImgs: ["https://i1.lensdump.com/i/TDPrtK.webp"],
    classImg: "regular",
  },
  {
    name: "Walking Man",
    imgUrl: "https://i1.lensdump.com/i/TDDcTc.gif",
    hrefUrl: "walking-man",
    medium: "2D Animation",
    info: "During the process of working on this animation, I developed and explored techniques for creating textures. using paint and other materials, I painted patterns and then used scans of them in my work",
    otherImgs: [
      "https://i1.lensdump.com/i/Tuy8sC.webp",
      "https://i.lensdump.com/i/TuyAu5.webp",
      "https://i3.lensdump.com/i/TuyiAz.webp",
    ],
    classImg: "card-tall",
    fullVid: "https://www.youtube.com/embed/3lyZo3Ph914",
  },
  {
    name: "Bonny",
    imgUrl: "https://i3.lensdump.com/i/TDDbcZ.webp",
    hrefUrl: "bonny",
    medium: "2D and 3D",
    info: "2D Character design transformed into a 3D Rig",
    otherImgs: [
      "https://i2.lensdump.com/i/TDPdt5.webp",
      "https://i3.lensdump.com/i/TDPqKz.webp",
    ],
    classImg: "regular",
  },
  {
    name: "Puppies",
    imgUrl: "https://i2.lensdump.com/i/TDDysm.gif",
    hrefUrl: "puppies",
    medium: "Mixed Media, 2D Animation",
    info: "Part of a personal short film-diary devoted to my identity as an Israeli citizen of Russian origin and my participation in the events of the military invasion of Ukraine by Russia",
    otherImgs: [
      "https://i.lensdump.com/i/Tu5Iic.webp",
      "https://i2.lensdump.com/i/TuyX40.webp",
      "https://i1.lensdump.com/i/TuybND.webp",
      "https://i2.lensdump.com/i/TuyydA.webp",
      "https://i3.lensdump.com/i/Tuy5LM.webp",
      "https://i1.lensdump.com/i/Tu58bk.webp",
      "https://i2.lensdump.com/i/Tu5jP1.webp",
      "https://i1.lensdump.com/i/Tu5ZdK.webp",
      "https://i3.lensdump.com/i/Tu59Mz.webp",
    ],
    classImg: "card-wide",
    fullVid: "https://www.youtube.com/embed/vvEM67_wyuk",
  },
  {
    name: "Ukraine in Tears",
    imgUrl: "https://i2.lensdump.com/i/TDPBfT.webp",
    hrefUrl: "ukraine-in-tears",
    medium: "Digital painting",
    info: "",
    otherImgs: [
      "https://i.lensdump.com/i/TuyLNC.webp",
      "https://i2.lensdump.com/i/TDPBfT.webp",
    ],
    classImg: "regular",
  },
  {
    name: "The Room",
    imgUrl: "https://i3.lensdump.com/i/TuwM12.webp",
    hrefUrl: "room",
    medium: "Digital painting",
    info: "",
    otherImgs: ["https://i3.lensdump.com/i/TuwM12.webp"],
    classImg: "regular",
  },
  {
    name: "Sea Warrior",
    imgUrl: "https://i3.lensdump.com/i/TDNWEC.jpeg",
    hrefUrl: "sea-warrior",
    medium: "Digital painting",
    info: "2D Character design",
    otherImgs: [
      "https://i2.lensdump.com/i/TDPiax.jpeg",
      "https://i3.lensdump.com/i/TDP06H.webp",
    ],
    classImg: "card-tall",
  },
  {
    name: "Sea Princess WIP",
    imgUrl: "https://i3.lensdump.com/i/TuwgLb.webp",
    hrefUrl: "sea-princess",
    medium: "2D Illustration",
    info: "2D Character lineart",
    otherImgs: ["https://i3.lensdump.com/i/TuwgLb.webp"],
    classImg: "regular",
  },
  {
    name: "Zif",
    imgUrl: "https://i.lensdump.com/i/TDDxZP.webp",
    hrefUrl: "zif",
    medium: "3D Animation Rig",
    info: "Zif is a character from a short film project about a shy middle-aged man and his tyrannical mother, whom he is forced to drag endlessly uphill.",
    otherImgs: [
      "https://i1.lensdump.com/i/TDPsjb.webp",
      "https://i.lensdump.com/i/Tu5dhT.webp",
      "https://i2.lensdump.com/i/Tu5B6b.webp",
    ],
    classImg: "card-wide",
    fullVid: "https://www.youtube.com/embed/_WIMyRXFpcs",
  },
  {
    name: "TSVETAEVA.OPEN",
    imgUrl: "https://i.lensdump.com/i/Tuwmzk.gif",
    hrefUrl: "tsvetaeva-open",
    medium: "2D Animation",
    info: "Animation scenes I created for the Documentary feature film “TSVETAEVA.OPEN” (2021)",
    otherImgs: [],
    classImg: "regular",
    fullVid: "https://www.youtube.com/embed/w74jMV_HhFU",
  },
  {
    name: "A Story About Libi",
    imgUrl: "https://i3.lensdump.com/i/TDD7ur.gif",
    hrefUrl: "a-story-about-libi",
    medium: "2D Animation",
    info: "This is a video essay I created as part of the Studio course. The work pictures controversial three-dimensional statements about myself.",
    otherImgs: [
      "https://i1.lensdump.com/i/TuyuLT.webp",
      "https://i1.lensdump.com/i/Tuyflr.gif",
      "https://i.lensdump.com/i/TuyPk7.webp",
      "https://i1.lensdump.com/i/Tuycr3.gif",
      "https://i3.lensdump.com/i/TuyDGb.webp",
      "https://i3.lensdump.com/i/TuyFXF.gif",
    ],
    classImg: "regular",
    fullVid: "https://www.youtube.com/embed/uw4jt7pdxak",
  },
  {
    name: "Self Portrait",
    imgUrl: "https://i3.lensdump.com/i/TDDYZQ.webp",
    hrefUrl: "self-portrait-2022",
    medium: "Digital painting",
    info: "",
    otherImgs: ["https://i3.lensdump.com/i/TDDYZQ.webp"],
    classImg: "card-tall",
  },
  {
    name: "Puppies",
    imgUrl: "https://i1.lensdump.com/i/TDDuue.png",
    hrefUrl: "puppies",
    medium: "Mixed Media, 2D Animation",
    info: "Part of a personal short film-diary devoted to my identity as an Israeli citizen of Russian origin and my participation in the events of the military invasion of Ukraine by Russia",
    otherImgs: [
      "https://i.lensdump.com/i/Tu5Iic.webp",
      "https://i2.lensdump.com/i/TuyX40.webp",
      "https://i1.lensdump.com/i/TuybND.webp",
      "https://i2.lensdump.com/i/TuyydA.webp",
      "https://i3.lensdump.com/i/Tuy5LM.webp",
      "https://i1.lensdump.com/i/Tu58bk.webp",
      "https://i2.lensdump.com/i/Tu5jP1.webp",
      "https://i1.lensdump.com/i/Tu5ZdK.webp",
      "https://i3.lensdump.com/i/Tu59Mz.webp",
    ],
    classImg: "regular",
    fullVid: "https://www.youtube.com/embed/vvEM67_wyuk",
  },
  {
    name: "Self Portrait",
    imgUrl: "https://i3.lensdump.com/i/TDDF51.webp",
    hrefUrl: "self-portrait",
    medium: "Digital Painting",
    info: "",
    otherImgs: ["https://i1.lensdump.com/i/Tu5swr.webp"],
    classImg: "regular",
  },
  {
    name: "Ukraine in Tears",
    imgUrl: "https://i1.lensdump.com/i/TDDPQx.png",
    hrefUrl: "ukraine-in-tears",
    medium: "Digital painting",
    info: "",
    otherImgs: [
      "https://i.lensdump.com/i/TuyLNC.webp",
      "https://i2.lensdump.com/i/TDPBfT.webp",
    ],
    classImg: "regular",
  },
  {
    name: "Cafe Nadi",
    imgUrl: "https://i2.lensdump.com/i/TuySX9.webp",
    hrefUrl: "cafe-nadi",
    medium: "Digital painting",
    info: "",
    otherImgs: ["https://i2.lensdump.com/i/TuySX9.webp"],
    classImg: "card-wide",
  },
  {
    name: "My sister wants to say something to me",
    imgUrl: "https://i2.lensdump.com/i/Tuwsbx.gif",
    hrefUrl: "my-sister-wants-to-say-something-to-me",
    medium: "2D Animation",
    info: "When I have a strong stream of emotion and inspiration, I often have the desire to frame it in one completed piece. Thanks to single quick sessions, loop animations allow me to capture fresh feelings.",
    otherImgs: [],
    classImg: "card-wide",
    fullVid: "https://www.youtube.com/embed/yrcIuXa6a3o",
  },
  {
    name: "Funny Girl",
    imgUrl: "https://i1.lensdump.com/i/TuwTb3.webp",
    hrefUrl: "funny-girl",
    medium: "Digital painting",
    info: "",
    otherImgs: ["https://i3.lensdump.com/i/TDP3q7.webp"],
    classImg: "regular",
  },
  {
    name: "Forget Safety",
    imgUrl: "https://i3.lensdump.com/i/TuwVdM.gif",
    hrefUrl: "forget-safety",
    medium: "Stop Motion Animation",
    info: "Based on Rumi's quote",
    otherImgs: [],
    classImg: "regular",
    fullVid: "https://www.youtube.com/embed/tJHkRImejqM",
  },
  {
    name: "Animator's Nightmare",
    imgUrl: "https://i1.lensdump.com/i/TDNCXA.webp",
    hrefUrl: "nightmare",
    medium: "Stop Motion Animation",
    info: "As creators, we often feel like we're in a production loop. For me and Yonatan with whom we made this animation, there is often an obsessiveness that makes it hard to stop working. it drives you mad and makes you sit for hours straight over the process. the consequences and the illusions in perception caused by this exhaustion are what we made this project about.",
    otherImgs: [],
    classImg: "card-wide",
    fullVid: "https://www.youtube.com/embed/JTn5ybMvJqE",
  },
  {
    name: "Cafe Nadi",
    imgUrl: "https://i.lensdump.com/i/TuwZdT.webp",
    hrefUrl: "cafe-nadi",
    medium: "Digital Art",
    info: "Digital Illustration",
    otherImgs: [
      "https://i2.lensdump.com/i/TuySX9.webp",
      "https://i1.lensdump.com/i/TDPIz1.webp",
    ],
    classImg: "regular",
  },
];

export default Projects;
